var map = {
	"./aiassistant.en.json": [
		4157,
		[
			157
		]
	],
	"./aiassistant.nl.json": [
		1184,
		[
			184
		]
	],
	"./aiassistant.sv.json": [
		2407,
		[
			407
		]
	],
	"./discovery.en.json": [
		817,
		[]
	],
	"./discovery.nl.json": [
		1732,
		[]
	],
	"./discovery.sv.json": [
		5987,
		[]
	],
	"./livechat.en.json": [
		7219,
		[
			219
		]
	],
	"./livechat.sv.json": [
		7953,
		[
			953
		]
	],
	"./translations.en.json": [
		3767,
		[]
	],
	"./translations.nl.json": [
		8970,
		[]
	],
	"./translations.sv.json": [
		445,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3156;
module.exports = webpackAsyncContext;